import React, { useEffect, useMemo, useRef, useState } from 'react'
import { ImSpinner2 } from 'react-icons/im'
import { TooltipIcon } from './Tooltips/TooltipInfos';
import "../../styles/card.css"

export const Cards = (props) => {
    const { data, isLoading = false } = props;
    const cardRef = useRef(null);
    const [cardsPorLinha, setCardsPorLinha] = useState(1);


    useEffect(() => {
        if (!cardRef.current) return;

        const updateCardsPerRow = () => {
            const gridWidth = cardRef.current.offsetWidth;
            const firstCard = cardRef.current.querySelector(".kpi-card");
            const cardWidth = firstCard ? firstCard.offsetWidth : 150;

            setCardsPorLinha(Math.floor(gridWidth / cardWidth));
        };

        const resizeObserver = new ResizeObserver(updateCardsPerRow);
        resizeObserver.observe(cardRef.current);

        updateCardsPerRow();

        return () => resizeObserver.disconnect();
    }, []);


    const sobra = data.length % cardsPorLinha;
    const placeholders = sobra === 0 ? [] : Array(cardsPorLinha - sobra).fill(null);

    // ✅ Mapeamento de labels para tooltips
    const labelToTooltip = {
        // Português
        "Veículos Ativos": "DASHBOARD_CARDS_ACTIVE_VEHICLES",
        "Odômetro Total": "DASHBOARD_CARDS_TOTAL_ODOMETER",
        "Km Horário Comercial": "DASHBOARD_CARDS_KM_BUSINESS_HOURS",
        "Km Fora do Horário Comercial": "DASHBOARD_CARDS_KM_OUTSIDE_HOURS",
        "Tempo de Uso": "DASHBOARD_CARDS_ENGINE_TIME",
        "Tempo Ocioso": "DASHBOARD_CARDS_IDLE_TIME",
        "Tempo Desligado": "DASHBOARD_CARDS_OFF_TIME",
        "Ocorrências Acima do Limite da Via": "DASHBOARD_CARDS_SPEED_LIMIT_DISTANCE",
        "Ocorrências Acima do Limite da Empresa": "DASHBOARD_CARDS_COMPANY_SPEED_LIMIT_DISTANCE",
        
        // English
        "Active Vehicles": "DASHBOARD_CARDS_ACTIVE_VEHICLES",
        "Total Odometer": "DASHBOARD_CARDS_TOTAL_ODOMETER",
        "Work Hours Distance": "DASHBOARD_CARDS_KM_BUSINESS_HOURS",
        "Outside Work Hours Distance": "DASHBOARD_CARDS_KM_OUTSIDE_HOURS",
        "Engine Time": "DASHBOARD_CARDS_ENGINE_TIME",
        "Idle Time": "DASHBOARD_CARDS_IDLE_TIME",
        "Off Time": "DASHBOARD_CARDS_OFF_TIME",
        "Speed Limit Distance": "DASHBOARD_CARDS_SPEED_LIMIT_DISTANCE",
        "Company Speed Limit Distance": "DASHBOARD_CARDS_COMPANY_SPEED_LIMIT_DISTANCE",
        
        // Español
        "Vehículos Activos": "DASHBOARD_CARDS_ACTIVE_VEHICLES",
        "Odómetro Total": "DASHBOARD_CARDS_TOTAL_ODOMETER",
        "Distancia en Horario Laboral": "DASHBOARD_CARDS_KM_BUSINESS_HOURS",
        "Distancia Fuera del Horario Laboral": "DASHBOARD_CARDS_KM_OUTSIDE_HOURS",
        "Tiempo de Uso": "DASHBOARD_CARDS_ENGINE_TIME",
        "Tiempo Detenido": "DASHBOARD_CARDS_IDLE_TIME",
        "Tiempo Apagado": "DASHBOARD_CARDS_OFF_TIME",
        "Distancia con Exceso de Velocidad": "DASHBOARD_CARDS_SPEED_LIMIT_DISTANCE",
        "Distancia con Velocidad Excedida a los Límites de la Empresa": "DASHBOARD_CARDS_COMPANY_SPEED_LIMIT_DISTANCE",
    };

    const getTooltipKey = (label) => {
        return labelToTooltip[label] || "";
    };

    return (
        <div className="kpi-grid" ref={cardRef}>
            {isLoading ? (
                Array.from({ length: 10 }, (_, index) => (
                    <div key={`loading-${index}`} className="kpi-card kpi-card-loading">
                        <div className="kpi-icon-loading">
                            <ImSpinner2 className="spinner" />
                        </div>
                        <div className="kpi-description">
                            <div className="kpi-label-loading"></div>
                            <div className="kpi-value-loading"></div>
                        </div>
                    </div>
                ))
            ) : (
                <>
                    {data.map((kpi, index) => {
                        const isTimeCard = kpi.label.includes('Tempo') || kpi.label.includes('Time') || kpi.label.includes('Tiempo');
                        const isVehicleCard = kpi.label.includes('Veículos') || kpi.label.includes('Vehicles') || kpi.label.includes('Vehículos');
                        const isDistanceCard = 
                        kpi.label.includes('Km') 
                        || kpi.label.includes('Total Odometer')
                        || kpi.label.includes('Odómetro Total')
                        || kpi.label.includes('Odômetro Total');
                        return (
                            <div key={index} className="kpi-card">
                                <kpi.icon className="kpi-icon" />
                                <div className="kpi-description">
                                    <div className="kpi-label">
                                        {kpi.label}
                                    </div>
                                    <div className="kpi-value">{isDistanceCard ? `${kpi.value} Km` : kpi.value}</div>
                                </div>
                                <div className="kpi-card-tooltip">
                                    {getTooltipKey(kpi.label) && (
                                        <TooltipIcon
                                            tooltipKey={getTooltipKey(kpi.label)}
                                            placement="bottom"
                                        />
                                    )}
                                </div>
                            </div>
                        );
                    })}

                    {placeholders.map((_, i) => (
                        <div key={`p-${i}`} className="kpi-card"></div>
                    ))}
                </>
            )}
        </div>
    )
}
